import React, { useState } from 'react';
import { changePassword } from '../api';
import logo from '../logo.png';

export default function ForceChangePassword({ onDone, onLogout }) {
  const [oldPw,     setOldPw]     = useState('');
  const [newPw,     setNewPw]     = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error,     setError]     = useState('');
  const [loading,   setLoading]   = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!oldPw || !newPw || !confirmPw) { setError('All fields are required'); return; }
    if (newPw !== confirmPw) { setError('New passwords do not match'); return; }
    if (newPw.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (newPw === 'Pashupati@2026') { setError('Please choose a different password'); return; }
    setLoading(true);
    changePassword(oldPw, newPw)
      .then(() => onDone())
      .catch(err => {
        setError(err.response?.data?.detail || 'Failed to change password');
        setLoading(false);
      });
  };

  const inputStyle = {
    width: '100%', padding: '12px 16px',
    border: '1px solid #e0d8d5', borderRadius: 8,
    fontSize: 14, outline: 'none', marginBottom: 16,
    color: '#333', background: '#fdfcfc', boxSizing: 'border-box',
  };

  const labelStyle = {
    fontSize: 12, color: '#444', fontWeight: 600,
    marginBottom: 6, display: 'block',
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#6B1C2A',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: 24,
    }}>
      <img src={logo} alt="Pashupati Capital" style={{ height: 48, marginBottom: 32 }} />

      <div style={{
        background: '#fff', borderRadius: 16, padding: '36px 40px',
        width: '100%', maxWidth: 420,
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
      }}>
        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#1a1a1a', marginBottom: 6 }}>
            Change Your Password
          </div>
          <div style={{
            background: '#fff8e1', border: '1px solid #ffe082',
            borderRadius: 8, padding: '10px 14px',
            fontSize: 13, color: '#856404', lineHeight: 1.5,
          }}>
            Your password has been reset by admin. Please set a new password to continue.
          </div>
        </div>

        {error && (
          <div style={{
            background: '#fdf0f0', border: '1px solid #f5c6c6',
            borderRadius: 8, padding: '10px 14px',
            fontSize: 13, color: '#c0392b', marginBottom: 16, lineHeight: 1.5,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="off">
          <label style={labelStyle}>Current Password (Pashupati@2026)</label>
          <input
            style={inputStyle} type="password"
            placeholder="Enter current password" value={oldPw}
            onChange={e => setOldPw(e.target.value)}
            onFocus={e => e.target.style.borderColor = '#6B1C2A'}
            onBlur={e => e.target.style.borderColor = '#e0d8d5'}
          />

          <label style={labelStyle}>New Password</label>
          <input
            style={inputStyle} type="password"
            placeholder="Min 8 characters" value={newPw}
            onChange={e => setNewPw(e.target.value)}
            onFocus={e => e.target.style.borderColor = '#6B1C2A'}
            onBlur={e => e.target.style.borderColor = '#e0d8d5'}
          />

          <label style={labelStyle}>Confirm New Password</label>
          <input
            style={inputStyle} type="password"
            placeholder="Repeat new password" value={confirmPw}
            onChange={e => setConfirmPw(e.target.value)}
            onFocus={e => e.target.style.borderColor = '#6B1C2A'}
            onBlur={e => e.target.style.borderColor = '#e0d8d5'}
          />

          <button type="submit" disabled={loading}
            style={{
              width: '100%', padding: 13,
              background: '#6B1C2A', color: '#fff',
              border: 'none', borderRadius: 8,
              fontSize: 14, fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.8 : 1, marginTop: 4,
            }}>
            {loading ? 'Saving...' : 'Set New Password & Continue'}
          </button>
        </form>

        <button onClick={onLogout}
          style={{
            width: '100%', padding: 10, marginTop: 10,
            background: 'transparent', color: '#888',
            border: '1px solid #e0d8d5', borderRadius: 8,
            fontSize: 13, cursor: 'pointer',
          }}>
          Logout
        </button>
      </div>

      <div style={{ marginTop: 20, fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
        Pashupati Capital Services Pvt. Ltd.
      </div>
    </div>
  );
}
